import { render, staticRenderFns } from "./fileTypes-editor.vue?vue&type=template&id=c16f84a0&scoped=true"
import script from "./fileTypes-editor.vue?vue&type=script&lang=js"
export * from "./fileTypes-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16f84a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16f84a0')) {
      api.createRecord('c16f84a0', component.options)
    } else {
      api.reload('c16f84a0', component.options)
    }
    module.hot.accept("./fileTypes-editor.vue?vue&type=template&id=c16f84a0&scoped=true", function () {
      api.rerender('c16f84a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-file/fileTypes-editor.vue"
export default component.exports